import type { HeaderSearchProps } from '@presentation/components';
import { Container } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';

export { HeaderSearchInputWrapper } from './styled';
export * from './types';

export const HeaderSearch: FC<HeaderSearchProps> = (props) => {
  const {
    title,
    subtitle,
    backgroundImage,
    children,
    childrenWrapperProps,
    childrenWrapperContainerProps,
    hasMobileWrap = false,
    bannerChildren,
    titleColor = 'blue',
    ...rest
  } = props;

  return (
    <>
      <Styled.Banner {...rest} src={backgroundImage} hasChildren={!!children}>
        <Container>
          {!!title && <Styled.Title titleColor={titleColor}>{title}</Styled.Title>}
          {!!subtitle && <Styled.Subtitle titleColor={titleColor}>{subtitle}</Styled.Subtitle>}
        </Container>
        {bannerChildren}
      </Styled.Banner>
      {!!children && (
        <Styled.Container {...childrenWrapperContainerProps}>
          <Styled.SearchWrapper hasMobileWrap={hasMobileWrap} {...childrenWrapperProps}>
            {children}
          </Styled.SearchWrapper>
        </Styled.Container>
      )}
    </>
  );
};
